import React from 'react';

import { useAppSelector } from '@fd/customHooks/useAppSelector';
import { Property } from '@flipdish/orgmanagement';

import SettingsList from '@fd/ui/List/SettingsList';

import { flagService } from '../../../services/flagService/flagService';
import { useIsPhoneNumbersPageOn } from '../../PhoneAgent/phoneNumbersPage';
import { getPropertySettingsMenuItems } from '../utils';

const PropertySettingsList = ({ appId, property }: { appId: string; property: Property }) => {
  const isShowCollectionSettingsAtPropertyLevelOn = useAppSelector((state) =>
    flagService.isFlagOn(state, 'showCollectionSettingsAtPropertyLevel')
  );
  const isPhoneNumbersPageOn = useIsPhoneNumbersPageOn();
  const menuItems = getPropertySettingsMenuItems({
    appId,
    property,
    isShowCollectionSettingsAtPropertyLevelOn,
    isPhoneNumbersPageOn,
  });

  return <SettingsList menuItems={menuItems} />;
};

export default PropertySettingsList;
